import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import { jsx } from '@emotion/core';
import Dialog from '@xkit/dialog';

var SideSheet = function SideSheet(_ref) {
  var children = _ref.children,
      Dialog = _ref.components.Dialog,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "components"]);

  return jsx(Dialog, _extends({
    styles: {
      transitionConfig: {
        spring: {
          from: {
            opacity: 0,
            x: 100
          },
          enter: {
            opacity: 1,
            x: 0
          },
          leave: {
            opacity: 0,
            x: 100
          },
          config: {
            friction: 25,
            tension: 250,
            clamp: true
          }
        },
        overlay: function overlay(_ref2) {
          var opacity = _ref2.opacity;
          return {
            opacity: opacity
          };
        },
        dialog: function dialog(_ref3) {
          var x = _ref3.x;
          return {
            transform: x.interpolate(function (s) {
              return "translateX(" + s + "%)";
            })
          };
        }
      },
      dialog: {
        position: 'fixed',
        right: 0,
        top: 0,
        bottom: 0,
        width: 620,
        maxWidth: 620,
        marginTop: 0,
        overflowY: 'auto',
        borderRadius: 0,
        boxShadow: 'none',
        outline: 'none'
      }
    }
  }, props), children);
};

SideSheet.defaultProps = {
  components: {
    Dialog: Dialog
  }
};

export default SideSheet;
